import $ from 'jquery';
import scrollTo from './lib/scroll-to';

export default function({
    selector     = '.scroll-up',
    duration     = 1000,
    offsetTop    = 300,
    scrollOffset = 0
} = {}) {
    var $scrollUp = $(selector);

    // scroll top on click
    $scrollUp.on('click', function(event) {
        event.preventDefault();

        scrollTo({
            top:      scrollOffset,
            duration: duration
        });
    });

    // only show the button after the offset
    $(window).scroll(function() {
        if (window.pageYOffset >= offsetTop) {
            $scrollUp.fadeIn('fast');
        } else {
            $scrollUp.fadeOut('fast');
        }
    });
}



// WEBPACK FOOTER //
// ./~/@spinnwerk/scroll-helper/scroll-up.js